import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'authenticator.onboarding.profileSummary.title',
    defaultMessage: 'What we understood about your company',
  },
  confidenceLow: {
    id: 'authenticator.onboarding.profileSummary.confidenceLow',
    defaultMessage:
      'Inferred from the company name alone: check every answer before confirming.',
  },
  confidenceMedium: {
    id: 'authenticator.onboarding.profileSummary.confidenceMedium',
    defaultMessage: 'Partly inferred: check the answers before confirming.',
  },
  confidenceHigh: {
    id: 'authenticator.onboarding.profileSummary.confidenceHigh',
    defaultMessage: 'Answers are pre-selected, correct anything that is wrong.',
  },
});
